import clsx from 'clsx';
import { type InputHTMLAttributes, type ReactNode, forwardRef, useId } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: ReactNode;
  hint?: ReactNode;
  error?: ReactNode;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { label, hint, error, className, id, ...rest },
  ref,
) {
  const auto = useId();
  const inputId = id ?? auto;
  const hintId = hint ? `${inputId}-hint` : undefined;
  const errorId = error ? `${inputId}-err` : undefined;

  return (
    <div className="perch-input-root">
      {label ? (
        <label className="perch-input-label" htmlFor={inputId}>
          {label}
        </label>
      ) : null}
      <input
        ref={ref}
        id={inputId}
        className={clsx('perch-input', className)}
        aria-invalid={error ? true : undefined}
        aria-describedby={[hintId, errorId].filter(Boolean).join(' ') || undefined}
        {...rest}
      />
      {hint && !error ? (
        <span id={hintId} className="perch-text" data-variant="body-s" data-tone="whisper">
          {hint}
        </span>
      ) : null}
      {error ? (
        <span id={errorId} className="perch-text" data-variant="body-s" data-tone="ember">
          {error}
        </span>
      ) : null}
    </div>
  );
});
